Promise.all([
  import(/* webpackMode: "eager" */ './park-summary-tabs.scss'),
  import('../tab-park-info/tab-park-info'),
  import('../tab-see-and-do/tab-see-and-do'),
  /*import('../reviews/reviews'), // Reviews tab commented out*/
  import('../groups-functions/groups-functions'),
  import('../tab-current-deals/tab-current-deals'),
]).then(() => {
  $('.widget.park-summary-tabs').each(function (i, el) {
    $(el).data('widget', new ParkSummaryTabs(el))
    $(el).data('widget').init()
  })
})

function ParkSummaryTabs(el) {
  const self = this
  self.el = $(el)

  self.tabsToLoad = 2
  self.tabsLoaded = 0

  self.lastActiveTabName = ''

  self.updateUrlWithTab = function (name, title,updateUrl) {

    // Update the page title
    document.title = title

    // Append the tab name to the URL path
    //
    // '0/     1      /   2   /   3    /   4  /  5  '
    // '/caravan-parks/{state}/{region}/{slug}/{tab}'
    let segments = window.location.pathname.split('/')
    segments[5] = name // Adds tab name in 5th position of path segments

    const pathname = segments.join('/')

    let params = new URLSearchParams(window.location.search)
    params.delete('tab')

    const url = window.location.origin + pathname + '?' + params.toString()

    if(updateUrl == true) {
      history.pushState(null, title, url)
    }

  }

  self.setAllTabsNotActive = function () {
    self.el.find('.tab-container .tab').removeClass('active')
    self.el.find('.accordion-heading').removeClass('active')
    self.el.find('.tab-content').removeClass('active')
  }

  self.setTabActive = function (name,updateUrl = true) {
    self.setAllTabsNotActive()
    // If name empty or 'features' (which should only show on mobile), then show the first tab as active
    if (name === '' || name === 'features') {
      const firstTab = self.el.find(`.tab-container .tab[data-tab]`).first()
      name = firstTab.attr('data-tab')
    }

    ////Sets the active tab if a tab name is included in the base url.
    let tabs = self.el.find(`.tab-container .tab[data-tab]`)
    const defaultTab = 'park-info'
    let hasMatch = false
    $(tabs).each(function (tab) {
      let current_tab = $(tabs[tab])

      var path = window.location.pathname;
      let current_tab_name = current_tab.attr('data-tab');
      if (path.match('/' + current_tab_name)) {
        name = current_tab_name;
        hasMatch = true;
      }
    })
    let params = new URLSearchParams(window.location.search);
    let dealCode = params.get('dealCode');
    let firstTabTitle;
    if (!hasMatch) {
      name = defaultTab;
      firstTabTitle = self.el.find('.accordion-heading[data-tab="park-info"]').attr('data-title');
      self.updateUrlWithTab(name, firstTabTitle,false)
    }

    if(dealCode != '' && dealCode !== null && typeof dealCode != 'undefined') {
      name = 'current-deals';
      firstTabTitle = self.el.find('.accordion-heading[data-tab="current-deals"]').attr('data-title');
      self.updateUrlWithTab(name, firstTabTitle,false)
    }

    // Only set active tab on non-mobile viewports (768px and above)
    // On mobile, accordions should start closed
    if (window.innerWidth >= 768) {
      self.el.find(`.tab-container .tab[data-tab="${name}"]`).addClass('active')
      self.el.find(`.accordion-heading[data-tab="${name}"]`).addClass('active')
      self.el.find(`.tab-content[data-tab='${name}']`).addClass('active')
    }
  }

  self.removeTab = function (name)
  {

    self.el.find(`.tab-content[data-tab='${name}']`)
      .removeClass('active')
      .addClass('inactive');

    // Also hide the corresponding mobile button
    self.el.find(`.mobile-tab-buttons .mobile-tab-button[data-tab="${name}"]`).css('display', 'none');
  }

  self.reloadTab = function (name) {
    self.el.find(`.tab-container .tab[data-tab="${name}"]`).css('display', 'block');
    self.el.find(`.tab-content[data-tab='${name}']`)
      .addClass('active');

  }


  const displayAsTabs = function () {
    // Only set active tab on non-mobile viewports
    if (window.innerWidth >= 768) {
      self.setTabActive(self.lastActiveTabName,false)
    }
  }

  self.initTabs = function () {
    self.setAllTabsNotActive()
    let shouldLoadFirstTab = false
    let tabs = self.el.find(`.tab-container .tab[data-tab]`)

    //check if there is a selected tab base from url segments
    let lastUrlSegment = window.location.pathname.split("/").pop()
    if ($(".tab-container .tab[data-tab='" + lastUrlSegment + "']").length)
    {
      // Only set active tab on non-mobile viewports when URL specifies a tab
      if (window.innerWidth >= 768) {
        self.setTabActive(lastUrlSegment,false) // Ensures tab or accordion is expanded on page load
      }
      shouldLoadFirstTab = false
      return false // exit loop
    }


    $(tabs).each(function (tab) {
      let $tab = $(tabs[tab])
      if ($tab.hasClass('active')) {
        self.lastActiveTabName = $tab.attr('data-tab')

        // Only set active tab on non-mobile viewports when tab has active class
        if (window.innerWidth >= 768) {
          self.setTabActive(self.lastActiveTabName,false) // Ensures tab or accordion is expanded on page load
        }
        shouldLoadFirstTab = false
        return false // exit loop
      }

      shouldLoadFirstTab = true
    })

    const shouldDisplayAsTabs = window.matchMedia('(min-width: 1600px)')

    if (shouldLoadFirstTab && shouldDisplayAsTabs.matches) {
      const $firstTab = $(tabs[0])
      const firstTabName = $firstTab.attr('data-tab')
      console.log('firstTabName:', firstTabName)
      self.setTabActive(firstTabName,false)
    }

    shouldDisplayAsTabs.addEventListener('change', function (media) {
      if (media.matches) {
        displayAsTabs()
      }
    })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ParkSummaryTabs init', self)
    }

    // When tab is clicked
    self.el.find('.tab-container .tab').click(function (event) {
      event.preventDefault()

      const $tab = $(this)
      const name = $tab.attr('data-tab')
      const pageTitle = $tab.attr('data-title')

      self.updateUrlWithTab(name, pageTitle,true)
      self.setTabActive(name)

      self.lastActiveTabName = name
    })

    // When accordion heading is clicked
    self.el.find('.accordion-heading').click(function (event) {
      event.preventDefault()

      const $accordionHeading = $(this)
      const name = $accordionHeading.attr('data-tab')
      const pageTitle = $accordionHeading.attr('data-title')
      // toggle open/closed the accordion
      $accordionHeading.toggleClass('active')
      $accordionHeading.parents('.park-summary-tabs').find(`.tab-content[data-tab='${name}']`).toggleClass('active')

      if ($accordionHeading.hasClass('active')) {
        self.lastActiveTabName = name
      } else {
        self.lastActiveTabName = ''
      }

      self.updateUrlWithTab(name, pageTitle,true)

      if (self.el.find('.tab-content .features').length) {
        let widest = 0

        self.el.find('.feature').each(function (i, el) {
          const thisWidth = $(this).outerWidth()
          if (thisWidth > widest) {
            widest = thisWidth
          }

          if ($(window).width() > 1024) {
            $(el).find('.icon').popup({
              on: 'hover',
              position: 'top left',
            })
          }
        })
        if (widest !== 0) self.el.find('.feature').css('width', widest)
      }
    })

    window.dbs.globalEvents.subscribe('remove_tab', function (name) {
      self.removeTab(name)
      self.setTabActive(name,false)
    })

    window.dbs.globalEvents.subscribe('reload_tab', function (name) {
      self.reloadTab(name);
    })



    // Window resize handler to manage tab states and close modals when changing viewports
    let resizeTimeout
    let wasDesktop = window.innerWidth >= 768
    $(window).on('resize.park-summary-tabs', function() {
      // Debounce resize events to improve performance
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(function() {
        const isDesktop = window.innerWidth >= 768

        // Close any open modals when viewport becomes medium (tablet) or larger (≥768px)
        // This covers transitions from mobile to tablet and mobile to desktop
        if (isDesktop) {
          self.closeAllModals()

          // If transitioning from mobile to desktop, set active tab
          if (!wasDesktop) {
            displayAsTabs()
          }
        } else {
          // If transitioning from desktop to mobile, close all tabs
          if (wasDesktop) {
            self.setAllTabsNotActive()
          }
        }

        wasDesktop = isDesktop
      }, 150)
    })

    // Keep track of how many tabs we need loaded before we show this widget on the page.
    // This allows us to avoid displaying tabs with empty content, because the content is being
    // requested by an endpoint or other dynamic source.
    window.dbs.globalEvents.subscribe('tab_loaded', function () {
      self.tabsLoaded++
      if (self.tabsLoaded >= self.tabsToLoad) {
        self.initTabs()
      }
      self.el.css('opacity', 1)
    })

    // emit 'was_tab_loaded' is used to double-check if any tabs were loaded before this script was init.
    // In which case, would mean we did not count that loaded tab as loaded, and this would then fail to
    // init the tabs via the subscribe 'tab_loaded' event, causing this widget to now show on the page.
    window.dbs.globalEvents.emit('was_tab_loaded', null, true)
  }

  self.showTabModal = function (tabName, tabTitle) {
    const modal = document.getElementById(`parkTabModal_${tabName}`)
    if (!modal) return

    // Copy content from the corresponding tab
    self.copyTabContentToModal(tabName)

    // Prevent body scroll on mobile when bottom sheet is open
    if (window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden'
    }

    // Show modal with proper animation timing
    modal.style.display = 'block'

    // Force a reflow to ensure display change is applied
    modal.offsetHeight

    // Add show class on next frame to trigger animation
    requestAnimationFrame(() => {
      modal.classList.add('show')
    })

    // Initialize modal close handlers if not already done
    if (!modal.dataset.handlersInitialized) {
      self.initModalHandlers(modal, tabName)
      modal.dataset.handlersInitialized = 'true'
    }
  }

  self.copyTabContentToModal = function (tabName) {
    const sourceContent = self.el.find(`.tab-content[data-tab='${tabName}']`)
    const targetContainer = document.querySelector(`#parkTabModal_${tabName} .tab-content-copy[data-tab='${tabName}']`)

    if (sourceContent.length && targetContainer) {
      // Clone the content, excluding the accordion heading
      const contentToClone = sourceContent.find('.widget, .features, .layout, .copy, .icon-content, .contact-accordion, .group-enquiry-accordion').clone()
      targetContainer.innerHTML = contentToClone.length ? contentToClone[0].outerHTML : sourceContent.html()

      // Initialize map lazy loading for park-info tab in modal
      if (tabName === 'park-info') {
        self.initModalMapLazyLoading(targetContainer)
      }
    }
  }

  self.initModalHandlers = function (modal, tabName) {
    const closeBtn = modal.querySelector('.close')

    function closeModal() {
      // Remove show class to trigger close animation
      modal.classList.remove('show')

      // Hide modal after animation completes
      setTimeout(() => {
        modal.style.display = 'none'
      }, 300) // Match the CSS transition duration

      // Re-enable body scroll
      document.body.style.overflow = ''
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal)
    }

    // Close on backdrop click
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal()
      }
    })

    // Add swipe down gesture support for mobile bottom sheet
    if (window.innerWidth <= 768) {
      self.addSwipeToCloseGesture(modal, closeModal)
    }
  }

  self.addSwipeToCloseGesture = function (modal, closeCallback) {
    let startY = 0
    let currentY = 0
    let isDragging = false

    const modalContent = modal.querySelector('.modal-content')
    if (!modalContent) return

    modalContent.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY
      isDragging = true
    })

    modalContent.addEventListener('touchmove', function (e) {
      if (!isDragging || window.innerWidth > 768) return

      currentY = e.touches[0].clientY
      const deltaY = currentY - startY

      if (deltaY > 0) {
        modalContent.style.transform = `translateY(${deltaY}px)`
      }
    })

    modalContent.addEventListener('touchend', function (e) {
      if (!isDragging || window.innerWidth > 768) return

      const deltaY = currentY - startY
      isDragging = false

      if (deltaY > 100) {
        // Swipe down threshold reached, close modal
        closeCallback()
      } else {
        // Snap back to original position
        modalContent.style.transform = ''
      }
    })
  }

  // Initialize map lazy loading for modal context
  self.initModalMapLazyLoading = function (modalContainer) {
    const mapContainer = modalContainer.querySelector('.map')
    if (!mapContainer) return

    const mapCanvas = modalContainer.querySelector('.map-canvas')
    if (!mapCanvas) return

    // Get coordinates from the map container
    const lat = parseFloat(mapContainer.getAttribute('data-lat'))
    const lng = parseFloat(mapContainer.getAttribute('data-lng'))

    if (isNaN(lat) || isNaN(lng)) {
      console.warn('Invalid coordinates for modal static map:', lat, lng)
      return
    }

    // Add loading placeholder for static map
    mapCanvas.innerHTML = `
      <div class="map-loading-placeholder" style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        background-color: #f5f5f5;
        border: 1px solid #ddd;
        color: #666;
        font-family: Arial, sans-serif;
        border-radius: 10px;
      ">
        <div style="text-align: center;">
          <div style="margin-bottom: 8px;">🗺️</div>
          <div>Map will load when visible</div>
        </div>
      </div>
    `

    // Mark that this map hasn't been loaded yet
    mapContainer.dataset.modalMapLoaded = 'false'

    // Check if Intersection Observer is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: load static map immediately if Intersection Observer is not supported
      self.loadModalStaticMap(mapContainer, mapCanvas, lat, lng)
      return
    }

    // Create Intersection Observer for modal static map
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && mapContainer.dataset.modalMapLoaded === 'false') {
          // Map container is visible in modal, load the static map
          self.loadModalStaticMap(mapContainer, mapCanvas, lat, lng)
          // Stop observing once the map is loaded
          observer.unobserve(mapContainer)
        }
      })
    }, {
      // Load static map when 10% of the container is visible
      threshold: 0.1,
      // Start loading 50px before the map enters the viewport
      rootMargin: '50px'
    })

    // Start observing the map container in the modal
    observer.observe(mapContainer)
  }

  // Load static map for modal context
  self.loadModalStaticMap = function (mapContainer, mapCanvas, lat, lng) {
    // Generate static map URL
    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap'
    const params = new URLSearchParams({
      center: `${lat},${lng}`,
      zoom: 12,
      size: '400x200',
      scale: 2, // For retina displays
      format: 'png',
      markers: `${lat},${lng}`,
      key: GOOGLE_MAPS_API_KEY,
      style: 'feature:poi|visibility:off', // Hide points of interest for cleaner look
    })

    const staticMapUrl = `${baseUrl}?${params.toString()}`

    // Create static map image
    const img = document.createElement('img')
    img.src = staticMapUrl
    img.alt = 'Park Location Map'
    img.style.width = '100%'
    img.style.height = '200px'
    img.style.objectFit = 'cover'
    img.style.display = 'block'
    img.style.cursor = 'pointer'
    img.title = 'Click to view in Google Maps'

    // Add loading and error handling
    img.onload = function() {
      mapCanvas.innerHTML = ''
      mapCanvas.appendChild(img)

      // Mark map as loaded
      mapContainer.dataset.modalMapLoaded = 'true'

      // Track static map load for optimization stats
      if (window.googleMapsOptimizer) {
        window.googleMapsOptimizer.trackMapLoad()
      }
    }

    img.onerror = function() {
      console.error('Static map failed to load for modal park-info')

      // Mark map as loaded (even though it failed) to prevent retry
      mapContainer.dataset.modalMapLoaded = 'true'

      mapCanvas.innerHTML = `
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 200px;
          background-color: #f5f5f5;
          border: 1px solid #ddd;
          color: #666;
          font-family: Arial, sans-serif;
          border-radius: 10px;
        ">
          <div style="text-align: center;">
            <div style="margin-bottom: 8px;">⚠️</div>
            <div>Map unavailable</div>
          </div>
        </div>
      `
    }

    // Add click handler to open full Google Maps
    img.onclick = function() {
      const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
      window.open(url, '_blank')
    }
  }



  self.closeAllModals = function () {
    // Find and close all park tab modals
    const modals = document.querySelectorAll('.park-tab-modal.show')
    modals.forEach(function(modal) {
      modal.classList.remove('show')

      // Hide modal after animation completes
      setTimeout(() => {
        modal.style.display = 'none'
      }, 300) // Match the CSS transition duration

      // Reset any transform that might be applied from swipe gestures
      const modalContent = modal.querySelector('.modal-content')
      if (modalContent) {
        modalContent.style.transform = ''
      }
    })

    // Re-enable body scroll
    document.body.style.overflow = ''
  }

  // Cleanup method for when widget is destroyed
  self.destroy = function () {
    // Remove resize event listener
    $(window).off('resize.park-summary-tabs')

    // Close any open modals
    self.closeAllModals()
  }
}
